export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/pedro-lastra-4f559a23cf5094a0248eab345556f7cf.jpg";